export const userSubDirectory = "/user";

export const loginUser = `${userSubDirectory}/login`;

export const updateUserFcmId = `${userSubDirectory}/updateFcmId`;

export const logoutUser = `${userSubDirectory}/logout`;

export const changePassword = `${userSubDirectory}/changePassword`;

export const getAllUsers = `${userSubDirectory}/getAllUsers`;

export const GET_USERS_PHONE_NUMBERS = `${userSubDirectory}/getAllUserPhoneNumbers`;

export const GET_ALL_SALES_USERS = `${userSubDirectory}/getAllSalesUsers`;

export const GET_SALES_USER = `${userSubDirectory}/:userId/getSalesUser`;

export const GET_SALES_ROLE_LIST = `${userSubDirectory}/getSalesRoleList`;

export const deactivateUser = `deactivateUser`;

export const createUser = `${userSubDirectory}/createUser`;

export const editUser = `editUser`;

export const validate2fa = `${userSubDirectory}/validate2fa`;

export const getUserAccess = `${userSubDirectory}/getUserAccess`;

export const updateRoleAccess = `${userSubDirectory}/updateRoleAccess`;

export const getRoleList = `${userSubDirectory}/getRoleList`;

export const getRoleAccess = `${userSubDirectory}/getRoleAccess`;

export const enable2fa = `${userSubDirectory}/enable2fa`;

export const check2faCode = `${userSubDirectory}/check2faCode`;

export const activateUser = `activateUser`;

export const getAllSkuSubCategoryApplicableUsers = `${userSubDirectory}/getAllSkuSubCategoryApplicableUsers`;

export const updateRoleSkuSubCategoryApplicable = `${userSubDirectory}/updateRoleSkuSubCategoryApplicable`;

export const getAllCommercialMappingApplicableUsers = `${userSubDirectory}/getAllCommercialMappingApplicableUsers`;

export const updateRoleCommercialMappingApplicable = `${userSubDirectory}/updateRoleCommercialMappingApplicable`;

export const getUsers = `${userSubDirectory}/getUsers`;

export const agentResetDeviceId = `${userSubDirectory}/:agentId/resetDeviceId`;

export const getAllNegativeMarginApprovalUsers = `${userSubDirectory}/getAllNegativeMarginApprovalUsers`;

export const requestNegativeMarginOtp = `${userSubDirectory}/requestNegativeMarginOtp/:selectedUserId`;
